<template>
  <div class="bottom-bar" :class="{ active: false, 'hide-btns': hideBtns }">
    <div class="bar-item active" @click="toInvite">
      <img
        class="icon"
        src="~images/qa/question/icon-yaoqing.png"
        alt=""
      /><span>邀请回答</span>
    </div>

    <div class="bar-item" @click="toAnswer" v-if="!isOnwer">
      <img class="icon" src="~images/qa/question/icon-huida.png" alt="" /><span
        >回答问题</span
      >
    </div>

    <div
      class="bar-item bao"
      :class="{ 'is-hug': detail.isZan }"
      @click="toBaobao"
      v-if="!isOnwer"
    >
      <div
        class="hand-mask"
        @click.stop
        v-if="!$platform.isYixinliApp"
        v-open-app="openAppConfig"
      ></div>
      <p class="bao-p">
        <img
          v-if="detail.isZan"
          class="icon"
          src="~images/qa/question/icon-baobao-ishug.png"
          alt=""
        />
        <img
          v-else
          class="icon"
          src="~images/qa/question/icon-baobaox.png"
          alt=""
        />
        <span class="baobaonum" v-if="+detail.baobaonum > 0">{{
          detail.baobaonum
        }}</span>
      </p>
      <p>抱抱题主</p>
    </div>
  </div>
</template>

<script>
import { addQueryToUrl } from 'lib/tools/utils.js'
import { directive } from '@yxl/open-app'
import { mapGetters } from 'vuex'
import { hug } from 'api/qa/questions.js'
import { commonGetToken } from 'utils/tool.js'

export default {
  inject: ['questionTags'],
  directives: {
    [directive.name]: directive
  },
  props: {
    isOnwer: Boolean,
    questionId: [String, Number],
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      hideBtns: false
    }
  },
  components: {},
  computed: {
    ...mapGetters(['isLogin', 'loginUser']),
    openAppConfig() {
      if (this.$isServer) return {}
      return {
        type: 'act',
        url: addQueryToUrl(window.location.href, {
          node: 1
        }),
        errAndroidUrl: 'https://sdata.xinli001.com/t/5s',
        errIosUrl: 'https://sdata.xinli001.com/t/5s'
      }
    }
  },
  created() {},
  mounted() {
    window.addEventListener('scroll', this.watchTop)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.watchTop)
  },
  methods: {
    watchTop() {
      this.hideBtns = true
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.hideBtns = false
      }, 500)
    },
    async checkLogin() {
      await this.$store.dispatch('getUserInfo')
      if (!this.isLogin) {
        this.toLogin()
        return false
      }
      return true
    },
    async toInvite() {
      // 神策埋点
      this.operationTrack('邀请回答')

      const flag = await this.checkLogin()
      if (flag) {
        const { env } = this.$runningEnv
        const s = env ? `-${env}` : ''
        const url = `https://m${s}.xinli001.com/qa/invitation-list?ask_id=${this.questionId}`
        if (this.$platform.isYixinliApp) {
          this.routerPush(url)
        } else {
          window.location.href = url
        }
      }
    },
    async toAnswer() {
      // 神策埋点
      this.operationTrack('回答问题')

      const flag = await this.checkLogin()
      if (flag) {
        // this.$toast('回答问题')
        this.$emit('toAnswer')
      }
    },
    async toBaobao() {
      const flag = await this.checkLogin()
      if (flag) {
        this.handleHug()
      }
    },
    handleHug() {
      if (this.huging) return
      this.huging = true
      return commonGetToken(this)
        .then(token => {
          return hug({
            token,
            object_id: this.questionId
          })
        })
        .then(({ code, message }) => {
          if (code === 0) {
            this.$toast({
              text: message || '抱抱成功',
              zIndexTop: true
            })
            // 神策埋点
            this.$trackEvent('qa_question_details_interaction', {
              ...this.questionTags,
              qa_id: this.$route.params.id, //问题ID
              interaction_type: '抱抱'
            })
            this.$emit('update')
          } else {
            this.$toast({
              text: message || '抱抱失败！',
              zIndexTop: true
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$toast({
            text: '网络异常！',
            zIndexTop: true
          })
        })
        .finally(() => {
          this.huging = false
        })
    },
    operationTrack(operation_type) {
      this.$trackEvent('qa_question_details_operation', {
        ...this.questionTags,
        qa_id: this.$route.params.id, //问题ID
        operation_type: operation_type
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.hide-btns {
  transform: translate(-50%, 160%) !important;
  opacity: 0;
}
.bottom-bar {
  transition: 0.5s all;
  position: fixed;
  bottom: 64px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  padding: 0 12px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 0px 40px 0px #ebefff;
  border-radius: 50px;
  &.active {
    background: transparent;
    justify-content: center;
  }
  .bar-item.bao {
    &.is-hug {
      font-weight: 500;
      color: #6982fa;
    }
    .hand-mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
  .bar-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 220px;
    height: 80px;
    border-radius: 40px;
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #434c5c;
    &.active {
      background: #6982fa;
      color: #ffffff;
    }
    .icon {
      margin-right: 8px;
      width: 32px;
      height: 32px;
    }
    .bao-p {
      position: relative;
      .baobaonum {
        position: absolute;
        top: 0;
        left: 80%;
        transform: translate(-50%, -50%);
        background: #fff;
        font-size: 16px;
        font-weight: 600;
        color: #434c5c;
        line-height: 18px;
        border-radius: 6px;
      }
    }
  }
}
</style>
